import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';

export const useDeleteVariation = () => {
  return useMutation({
    mutationFn: deleteVariation,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: queryKeys.assemblies.invalidateAll(),
        refetchType: 'none',
      });
      queryClient.invalidateQueries(queryKeys.assemblyTags.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewAssemblyTagsWithAssembliesCount.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceEligibleAssemblyIds.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.scheduleAssembliesSearch.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
    },
  });
};

const deleteVariation = async (variationId: number) => {
  const response = await requestCCApi({
    url: `/assemblies/${variationId}`,
    method: 'DELETE',
  });

  return response;
};
